import { Pipe, PipeTransform } from '@angular/core';
import { IGridRow } from '../interfaces/igrid-row.interface';

@Pipe({
	name: 'gridEvalRows',
	pure: true,
	standalone: true
})
export class NHAGridEvalRowsPipe implements PipeTransform {
	transform(rows: IGridRow[] | ((item: unknown) => IGridRow[]), item: unknown): IGridRow[] {
		if (typeof rows === 'function') {
			return rows(item);
		}
		return rows;
	}
}
